import { IconSVGProps } from "./types";

const CopyFillIcon = ({ height = 16, width = 16, className, onClick }: IconSVGProps) => (
    <svg
        className={className}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
    >
        <path
            d="M7.16602 0H11.0441C11.441 0 11.8223 0.159375 12.1035 0.440625L14.2254 2.5625C14.5066 2.84375 14.666 3.225 14.666 3.62188V10.5C14.666 11.3281 13.9941 12 13.166 12H7.16602C6.33789 12 5.66602 11.3281 5.66602 10.5V1.5C5.66602 0.671875 6.33789 0 7.16602 0ZM2.16602 4H4.66602V6H2.66602V14H8.66602V13H10.666V14.5C10.666 15.3281 9.99414 16 9.16602 16H2.16602C1.33789 16 0.666016 15.3281 0.666016 14.5V5.5C0.666016 4.67188 1.33789 4 2.16602 4Z"
            fill="#002649"
        />
    </svg>
);

export default CopyFillIcon;
